<template>
  <div class="body1">
    <div class="content">
      <img class="img" src="../../assets/eblock-01.png">
      <div class="title">E-Blocks English was built on sound pedagogical Research. It introduces children to the world of phonics, reading, and writing through five unique levels that promote letter-sound training (phonemic awareness), sight word practice, initial reading mechanics, reading comprehension skills, sentence structure awareness, an extend listening comprehension practice.<br>
        E-Blocks English is enhancing children’s education in pre-school, elementary schools, ESOL/ESL programs, special education, after schools and summer camps. Is has earned nation and international acclaim from educators' world.
      </div>
    </div>
  </div>
</template>

<script>
import 'swiper/css/swiper.css'
import { Swiper, SwiperSlide,directive } from 'vue-awesome-swiper'
export default {
  data() {
    return {
      swiperOptions: {
        pagination: {
          el: '.swiper-pagination',
          bulletClass : 'my-bullet',
          bulletActiveClass: 'my-bullet-active',
          clickable:true,
        },
        speed:2000,
        autoplay: {
          delay: 5000,
          disableOnInteraction: false
        },
        // loop:true,
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper
    }
  },
  mounted() {
  },
  methods: {}
}
</script>

<style scoped lang="less">
@import "../../assets/style/index";
.body1{
  height: 493px;
  display: flex;
  flex-direction: row;
  justify-content: center;
  background: #6D43A1;
  .content{
    .media-content;
    height: 100%;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    .title{
      text-align: left;
      color: white;
      font-size: 18px;
      font-family: 'Adobe Heiti Std', Helvetica, Arial, sans-serif;
      line-height: 30px;
    }
    .img{
      width: 510px;
      object-fit: contain;
      height: 377px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/eblocks/e-body1.vue